import React from "react";
import PermissionApprovedCard from "./PermissionApprovedCard.component";
import CoAdminPermissionList from "./CoAdminPermissionList.component";

const ActCoAdmin = () => {
  return (
    <div className="flex-col flex-1 w-full h-full radius-10 back-white  align-left  pt-2 pb-2 pl-3 pr-3 g-2">
      <h3 className="t-16 poppins color-black weight-500">
        Here you can add admin as an act admin. They can get all access except
        settings portion.
      </h3>
      <div className="flex-1 w-full flex-col align-left justify-start g-05">
        {/* already given permission list  */}
        <div
          style={{ height: "30%" }}
          className="w-full flex-col align-left justify-start border-2-grayBorder radius-10 scroll-y p-05 pr-1"
        >
          <PermissionApprovedCard
            image={""}
            id={""}
            adminType={""}
            designation={""}
          />
          <PermissionApprovedCard
            image={""}
            id={""}
            adminType={""}
            designation={""}
          />
        </div>
        <div
          style={{ height: "45vh" }}
          className="w-full flex-col align-left justify-start border-2-grayBorder radius-10 scroll-y p-05 pr-1"
        >
          <CoAdminPermissionList />
          <CoAdminPermissionList />
          <CoAdminPermissionList />
          <CoAdminPermissionList />
          <CoAdminPermissionList />
          <CoAdminPermissionList />
          <CoAdminPermissionList />
          <CoAdminPermissionList />
          <CoAdminPermissionList />
          <CoAdminPermissionList />
          <CoAdminPermissionList />
          <CoAdminPermissionList />
          <CoAdminPermissionList />
        </div>
      </div>
    </div>
  );
};

export default ActCoAdmin;
